module.exports = __webpack_public_path__ + "img/IMG_1539_FoamcoreMatted.9caf31f3.jpg";